import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "lib/i18n";
import { blogPosts } from "data/blogPosts";
import Seo from "components/Seo";

const getLocalizedValue = (value, language) => {
  if (value && typeof value === "object") {
    return value[language] || value.en || Object.values(value)[0];
  }
  return value;
};

const Blog = () => {
  const { t, language } = useTranslation();
  const isFrench = language === "fr";
  const title = isFrench
    ? "Perspectives en conseil logiciel et études de cas"
    : "Software Consulting Insights and Case Studies";
  const description = t("blog.subheading");
  const sortedPosts = [...blogPosts].sort((a, b) => (a.date < b.date ? 1 : -1));

  return (
    <>
      <Seo title={title} description={description} path="/blog" />
      <section className="blog section-title mt-5">
        <div className="container text-white">
          <div className="row align-items-center">
            <div className="col-md-7 mx-auto">
              <div className="blog-title mb-5 mt-5 text-center">
                <h1 className="title-font title-font-size">{t("blog.heading")}</h1>
                <p className="title-text mt-4 mb-4 title-font-2">{t("blog.subheading")}</p>
              </div>
            </div>
          </div>
          <div className={`row blog-cards-row ${sortedPosts.length === 1 ? "blog-row-single" : ""}`}>
            {sortedPosts.map((post) => {
              const title = getLocalizedValue(post.title, language);
              const summary = getLocalizedValue(post.summary, language);
              const category = getLocalizedValue(post.category, language);
              return (
                <div className="col-12 col-lg-6" key={post.id}>
                  <article className="blog-card">
                    <div className="blog-card-meta title-font-2">
                      <span className="blog-category">{category}</span>
                      <span className="blog-date">{post.date}</span>
                    </div>
                    <h2 className="blog-card-title title-font">{title}</h2>
                    <p className="blog-card-summary title-font-2">{summary}</p>
                    <Link className="blog-card-link" to={`/blog/${post.slug}`}>
                      {t("blog.readMore")}
                    </Link>
                    <div className="card-header-row">
                      <span className="card-tag">{t("labels.post")}</span>
                      <span className="card-dot" aria-hidden="true"></span>
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
